import React from 'react';
import { Box } from '@material-ui/core';

// @ts-ignore
const PageLoadError = ({ message }) => {
  return <Box>{message || 'Page Load Error'}</Box>;
};

export default PageLoadError;
